import axios from 'axios';
import store from '../store/store';
import { LOGOUT } from '../store/types/action-types';
import router from '../router/router';

axios.defaults.timeout = 30000;

axios.interceptors.request.use((config) => {
  if (store.state.token) config.headers.Authorization = `Bearer ${store.state.token}`;
  else config.headers.Authorization = '';
  // PNET-1849: la summary della pagina Canoni può essere lunga al primo accesso a un anno non ancora calcolato.
  // Timeout più ampio SOLO per questa chiamata (coerente col command timeout backend), senza toccare il default globale.
  if (config.url && config.url.includes('/economics/summary')) config.timeout = 120000;
  // Stesso motivo, stesso valore: la generazione del report fa una chiamata di calcolo **per ubicazione**
  // - su J0720AA sono 105 - e su un mese mai aperto ognuna ricalcola da zero. Con i 30 secondi di default
  // il browser mollava mentre il server finiva: il cliente vedeva «Errore Server» e ritrovava il report
  // nella lista poco dopo. Oltre i 230 secondi taglia comunque Azure, quindi questo e un tetto
  // provvisorio: la strada vera e rendere la generazione asincrona come l'import dei locali.
  if (config.url && config.url.includes('/billingreport/generate')) config.timeout = 120000;
  // Stessa famiglia: il template dell'import locali riversa in un foglio Excel **tutti** i locali con i
  // loro stati - su J0720AA sono 19.834 locali e 59.502 righe di stato.
  //
  // Qui pero' il browser non c'entrava: il cliente vedeva un **500**, non una richiesta scaduta, e App
  // Insights lo attribuiva alla scadenza lato database. La correzione vera sta nel backend
  // (`SiteService.GenerateImportRoomsTemplate`), che non moltiplica piu' i locali per le categorie e si
  // allarga il `CommandTimeout`. Questo resta il corrispettivo lato client: allargare un capo solo dei
  // due non sposta niente, perche' a mollare per primo e' sempre l'altro. Oltre i 230 secondi taglia
  // comunque Azure.
  if (config.url && config.url.includes('/site/rooms-template')) config.timeout = 120000;
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      const tokenExpired = error.response.headers['token-expired'] && !sessionStorage.getItem('token-expired');
      if (tokenExpired) {
        sessionStorage.setItem('token-expired', 'true');
        await store.dispatch(LOGOUT);
        if (router.currentRoute.name !== 'page-login') {
          router.push({ name: 'page-login' });
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
